import React, { useState } from "react";
import { Link } from "react-router-dom";
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, deleteUser } from "firebase/auth";
import { getFirestore, doc, deleteDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAQ8zxBUP3ldZCCIUnVDxv6aNkODnjyBjs",
  authDomain: "bill-calendar-969ba.firebaseapp.com",
  projectId: "bill-calendar-969ba",
  storageBucket: "bill-calendar-969ba.appspot.com",
  messagingSenderId: "818422130527",
  appId: "1:818422130527:web:5e0a59ddb648ac67fdf8ea",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const DeleteAccount = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [step, setStep] = useState("login"); // login | confirm | deleting | done | error
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setStep("confirm");
    } catch {
      setError("Invalid email or password. Please try again.");
    }
  };

  const handleDelete = async () => {
    setStep("deleting");
    setError("");
    try {
      const user = auth.currentUser;
      if (!user) throw new Error("Not authenticated");
      // Delete Firestore data first
      await deleteDoc(doc(db, "users", user.uid));
      // Delete the Firebase Auth account
      await deleteUser(user);
      setStep("done");
    } catch (err) {
      if (err?.code === "auth/requires-recent-login") {
        setError("For security, please sign in again and retry.");
        setStep("login");
      } else {
        setError("Failed to delete account. Please try again or contact support@paymaplabs.com.");
        setStep("error");
      }
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 16px",
    borderRadius: 10,
    border: "1px solid #334155",
    background: "#1e293b",
    color: "#e2e8f0",
    fontSize: "1rem",
    marginBottom: 12,
    outline: "none",
    boxSizing: "border-box",
  };

  const btnPrimary = {
    width: "100%",
    padding: "14px",
    borderRadius: 10,
    border: "none",
    background: "#3b82f6",
    color: "#fff",
    fontSize: "1rem",
    fontWeight: 600,
    cursor: "pointer",
  };

  const btnDanger = {
    ...btnPrimary,
    background: "#ef4444",
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#0f172a",
      color: "#e2e8f0",
      fontFamily: "Inter, system-ui, sans-serif",
    }}>
      <nav style={{
        padding: "16px 24px",
        borderBottom: "1px solid #1e293b",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}>
        <Link to="/" style={{ textDecoration: "none" }}>
          <span style={{ fontSize: "1.4rem", fontWeight: 900 }}>
            <span style={{ color: "#f1f5f9" }}>Pay</span>
            <span style={{ color: "#3b82f6" }}>Map</span>
          </span>
        </Link>
        <Link to="/" style={{ color: "#3b82f6", textDecoration: "none", fontWeight: 600 }}>
          ← Back
        </Link>
      </nav>

      <div style={{
        maxWidth: 440,
        margin: "0 auto",
        padding: "48px 24px",
        lineHeight: 1.7,
      }}>
        <h1 style={{ color: "#f1f5f9", fontSize: "2rem", fontWeight: 800, marginBottom: 8 }}>Delete Account</h1>
        <p style={{ color: "#94a3b8", marginBottom: 32 }}>
          Permanently delete your PayMap account and all associated data.
        </p>

        {step === "login" && (
          <form onSubmit={handleLogin}>
            <p style={{ marginBottom: 16, fontSize: "0.95rem" }}>
              Sign in to verify your identity before deleting your account.
            </p>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              style={inputStyle}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              style={inputStyle}
            />
            {error && <p style={{ color: "#ef4444", fontSize: "0.9rem", marginBottom: 12 }}>{error}</p>}
            <button type="submit" style={btnPrimary}>Sign In</button>
          </form>
        )}

        {step === "confirm" && (
          <div>
            <div style={{
              background: "rgba(239, 68, 68, 0.1)",
              border: "1px solid rgba(239, 68, 68, 0.3)",
              borderRadius: 12,
              padding: "20px",
              marginBottom: 24,
            }}>
              <p style={{ color: "#fca5a5", fontWeight: 600, fontSize: "1.05rem", marginBottom: 8 }}>
                ⚠️ This action is permanent and cannot be undone.
              </p>
              <p style={{ fontSize: "0.95rem", color: "#e2e8f0" }}>
                Deleting your account will permanently remove:
              </p>
              <ul style={{ paddingLeft: 20, fontSize: "0.95rem", color: "#cbd5e1" }}>
                <li>Your PayMap account and login credentials</li>
                <li>All calendars, bills, income entries, and payment history</li>
                <li>All preferences, categories, and color settings</li>
              </ul>
            </div>
            <div style={{ display: "flex", gap: 12 }}>
              <button
                onClick={() => { setStep("login"); setError(""); }}
                style={{ ...btnPrimary, background: "#334155" }}
              >
                Cancel
              </button>
              <button onClick={handleDelete} style={btnDanger}>
                Delete My Account
              </button>
            </div>
          </div>
        )}

        {step === "deleting" && (
          <div style={{ textAlign: "center", padding: "40px 0" }}>
            <p style={{ fontSize: "1.1rem" }}>Deleting your account...</p>
          </div>
        )}

        {step === "done" && (
          <div style={{
            background: "rgba(34, 197, 94, 0.1)",
            border: "1px solid rgba(34, 197, 94, 0.3)",
            borderRadius: 12,
            padding: "24px",
            textAlign: "center",
          }}>
            <p style={{ color: "#86efac", fontWeight: 600, fontSize: "1.1rem", marginBottom: 8 }}>
              ✓ Account Deleted
            </p>
            <p style={{ fontSize: "0.95rem", color: "#cbd5e1" }}>
              Your account and all associated data have been permanently removed.
            </p>
          </div>
        )}

        {step === "error" && (
          <div>
            {error && <p style={{ color: "#ef4444", marginBottom: 16 }}>{error}</p>}
            <button onClick={() => { setStep("login"); setError(""); }} style={btnPrimary}>
              Try Again
            </button>
          </div>
        )}

        <div style={{ marginTop: 40, paddingTop: 20, borderTop: "1px solid #1e293b" }}>
          <p style={{ color: "#94a3b8", fontSize: "0.85rem" }}>
            You can also delete your account from within the PayMap app (Settings → Delete Account),
            or by emailing <a href="mailto:support@paymaplabs.com" style={{ color: "#3b82f6" }}>support@paymaplabs.com</a>.
            See our <Link to="/privacy" style={{ color: "#3b82f6" }}>Privacy Policy</Link> for more details.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccount;
